import { render, staticRenderFns } from "./PriceCSVAnalysis.vue?vue&type=template&id=5aadd7a6&scoped=true&"
import script from "./PriceCSVAnalysis.vue?vue&type=script&lang=js&"
export * from "./PriceCSVAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./PriceCSVAnalysis.vue?vue&type=style&index=0&id=5aadd7a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aadd7a6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VIcon})
